import { render, staticRenderFns } from "./PrescriptionItem.vue?vue&type=template&id=e32fb684&scoped=true"
import script from "./PrescriptionItem.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32fb684",
  null
  
)

export default component.exports